<template>
  <b-card
    class="knav"
    style="background-color: #fafaff;"
    no-body>
    <h1
      style="display: inherit;"
      v-b-toggle="collapseId"
      :class="{collapsed: !subIsActive }">
      {{ title }}
    </h1>
    <b-collapse
      :id="collapseId"
      :visible="subIsActive()"
      class="subnav">

      <nav class="subnav nav flex-column nav-pills nav-editor">
        <slot/>
      </nav>

    </b-collapse>
  </b-card>
</template>

<script>
export default {
  props: {
    collapseId: {
      type: String,
      required: true,
    },
    subActiveCheck: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    subIsActive() {
      let paths = this.subActiveCheck;
      if (!Array.isArray(this.subActiveCheck)) {
        paths = [this.subActiveCheck];
      }

      return paths.some((path) => {
        const pathWithUid = path.replace(':userId', this.$route.params.userId);
        return this.$route.path.indexOf(pathWithUid) === 0;
      });
    },
  },
};
</script>

<style scoped>
.subnav {
  padding-left: 7px;
  margin: -5px 0 5px 0;
}
.knav h1 {
  margin-bottom: 0;
}
.knav > *:nth-child(odd)    {
  cursor: pointer;
}
.knav > *:nth-child(odd):before  {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  margin-right: 10px;
  vertical-align: middle;
  border-left: .25em solid transparent;
  border-right: .25em solid transparent;
  border-top: .25em solid;
  border-bottom: .25em solid transparent;
  transition: all 200ms ease;
  margin-top: 0.4em;
}
.knav > *:nth-child(odd).collapsed:before  {
  border-left: .25em solid;
  border-right: .25em solid transparent;
  border-top: .25em solid transparent;
  border-bottom: .25em solid transparent;
}
</style>
